'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'gem';
var width = 512;
var height = 512;
var aliases = [128142];
var unicode = 'f3a5';
var svgPathData = ['M77.3 176l123.2 0L127 97.9 77.3 176zM81 224L256 410 431 224l-175 0L81 224zM176 80l80 85 80-85L176 80zm135.5 96l123.2 0L385 97.9 311.5 176z', 'M289 445l-33 35-33-35L0 208 112 32l288 0L512 208 289 445zM431 224l-175 0L81 224 256 410 431 224zm3.7-48L385 97.9 311.5 176l123.2 0zM336 80L176 80l80 85 80-85zM127 97.9L77.3 176l123.2 0L127 97.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;